// @flow

import React from "react";

import { Col, Row, ChatBubble } from "../../";

type Props = {
  options: Object,
};

export const PostWidgetChatBubble = (props: Props) => (
  <React.Fragment>
    {props.options.chatBubbleText && props.options.showChatBubbleText ? (
      <Row className="mt-5">
        <Col>
          <ChatBubble message={props.options.chatBubbleText} />
        </Col>
      </Row>
    ) : null}
  </React.Fragment>
);

export default PostWidgetChatBubble;
